// extracted by mini-css-extract-plugin
export default {"box":"Home_box__b61zv","header":"Home_header__Eyvva","content":"Home_content__THXSj","photo":"Home_photo__zdGBQ"};